import { toast,Slide } from "react-toastify";
import { playClickSound,playErrorSound,playStartSound, playUploadSound } from '../lib/audio';


import "react-toastify/dist/ReactToastify.css";
import styles from '../assets/styles/toast.module.css'


const MAX_TOASTS = 3;
// Submit's result stays up longer than the app's 1.5 s default: it's the only word on what happened.
const SUBMIT_TOAST_MS = 3000;
const REAL_MAX_TOASTS = 6;
let activeToastIds = [];

/**
 * If more than the max toasts is displayed delete the oldest if trying to load a new one
 */
const dismissOldestIfNeeded = () => {
  if (activeToastIds.length >= MAX_TOASTS) {
    const oldestId = activeToastIds.shift();
    toast.dismiss(oldestId);
  }
};

/**
 * Checks if the max number of toast is already displayed
 * @returns 
 */
const cantLoadMore = () => {
    if(activeToastIds.length >= REAL_MAX_TOASTS){
        return true;
    } else return false;
}

/**
 * Adds the created toast to the array so it can be tracked 
 * @param {*} id the toast 
 */
const trackToast = (id) => {
  activeToastIds.push(id);
  toast.update(id, {
    onClose: () => {
      activeToastIds = activeToastIds.filter((tid) => tid !== id);
    },
  });
};

const Toast = {
    success: (msg) => {
        dismissOldestIfNeeded()
        const id = toast.success(msg, { className: `${styles.toast} ${styles.success}` })
        trackToast(id);
    },
    error: (msg,funnys = false,sfxEnabled = false) => {
        if(cantLoadMore()) return;
        dismissOldestIfNeeded()
        const id = toast.error(msg, { className: `${styles.toast} ${styles.error}`})
        playErrorSound(funnys,sfxEnabled)
        trackToast(id);
    },
    info: (msg) => {
        dismissOldestIfNeeded()
        const id = toast.info(msg, { className: `${styles.toast} ${styles.info}` })
        trackToast(id);
    },
    // Submit's levels (lib/submit.js): one toast, the highest level a record reached.
    uploaded: (msg) => {
        dismissOldestIfNeeded()
        const id = toast.success(msg, { className: `${styles.toast} ${styles.uploaded}`, autoClose: SUBMIT_TOAST_MS })
        trackToast(id);
    },
    exported: (msg) => {
        dismissOldestIfNeeded()
        const id = toast(msg, { className: `${styles.toast} ${styles.exported}`, icon: "⬆", autoClose: SUBMIT_TOAST_MS })
        trackToast(id);
    },
    saved: (msg) => {
        dismissOldestIfNeeded()
        const id = toast.info(msg, { className: `${styles.toast} ${styles.saved}`, autoClose: SUBMIT_TOAST_MS })
        trackToast(id);
    },
    warning: (msg) => {
        dismissOldestIfNeeded()
        const id = toast.warn(msg, { className: `${styles.toast} ${styles.warning}`, autoClose: 4000 })
        trackToast(id);
    },
};
export default Toast;